import React, { Component } from 'react';
import AccessContainer from '../../access/AccessContainer';
import { RootState } from '../../../redux/store';
import { changeApiVariable } from '../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AccessBase } from '../../../domain/access/BaseAccess';
import RoleHelper from '../../../RoleHelper';

class ApiAccessComponent extends Component<Props> {
  render() {
    const {
      apiVariable: { apiVariable },
    } = this.props;
    const access: AccessBase = { permission: apiVariable.permission, collaborators: apiVariable.collaborators };
    return <AccessContainer changeAccess={this.changeApiAccess} disabled={!RoleHelper.canManage('EnrichmentApi')} access={access} />;
  }

  public changeApiAccess = (access: AccessBase) => {
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
    } = this.props;
    apiVariable.permission = access.permission;
    apiVariable.collaborators = access.collaborators;
    changeApiVariable(apiVariable);
  };
}

interface Props extends ReduxType {}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
});

const mapDispatchToProps = { changeApiVariable };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxType = ConnectedProps<typeof connector>;

export default connector(ApiAccessComponent);
